import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '../../../abstract/base.component';
import { SegOption } from '../../../ui/segmented/payarc-segmented.component';

/**
 * The shared tab bar for Events & Logs' two list screens (Events / Webhook calls), same pattern
 * as app-payment-tabs: each tab is its own top-level route/component sharing this bar, rather than
 * a parent route with children — there's no other shared state between the two screens that would
 * need a parent shell.
 */
@Component({
  selector: 'app-events-tabs',
  template: `<payarc-segmented mobileMenu="always" [options]="options" [value]="activeTab" (valueChange)="goTo($event)"></payarc-segmented>`,
  styles: [':host { display: block; margin-bottom: 16px; }'],
  standalone: false
})
export class EventsTabsComponent extends BaseComponent {
  readonly options: SegOption[] = [
    { label: 'Events', value: '/events-and-logs' },
    { label: 'Webhook calls', value: '/events-and-logs/webhooks' },
  ];

  constructor(router: Router) {
    super();
    this.router = router;
  }

  get activeTab(): string {
    const url = this.router.url.split('?')[0];
    return this.options.find(o => url === o.value)?.value ?? this.options[0].value;
  }

  goTo(url: string) {
    this.router.navigateByUrl(url);
  }
}
